export function shuffleList(array: string[], hammingDistance: number): string[] {
    if (hammingDistance > array.length) {
        throw new Error('Hamming distance cannot be greater than array length');
    }

    let shuffledArray = [...array];
    let currentHammingDistance = 0;

    for (let i = 0; i < array.length; i++) {
        // If we've already achieved the required Hamming distance, break the loop
        if (currentHammingDistance === hammingDistance) {
            break;
        }

        // If the element at the current index is the same in both arrays, swap it with a different element
        if (shuffledArray[i] === array[i]) {
            let swapIndex = (i + 1 + Math.floor(Math.random() * (array.length - 1))) % array.length;

            // Swap elements
            let temp = shuffledArray[i];
            shuffledArray[i] = shuffledArray[swapIndex];
            shuffledArray[swapIndex] = temp;

            currentHammingDistance++;
        }
    }

    return shuffledArray;
}




export function computeEditDistance(s1: string[], s2: string[]): number {
    if (s1.length !== s2.length) {
        throw new Error("Both strings must have the same length");
    }

    let distance = 0;
    for (let i = 0; i < s1.length; i++) {
        let pos1 = s1.indexOf(s2[i]);
        let pos2 = i;

        while (pos1 !== pos2) {
            if (pos1 < pos2) {
                [s1[pos1], s1[pos1 + 1]] = [s1[pos1 + 1], s1[pos1]];
                pos1++;
            } else {
                [s1[pos1], s1[pos1 - 1]] = [s1[pos1 - 1], s1[pos1]];
                pos1--;
            }
            distance++;
        }
    }
    return distance;
}
